module.exports = __webpack_public_path__ + "static/img/218b76b862b1bcf7(3).82427523.png";